const selectors = {
  block: '[data-ingredients-block]',
  button: '[data-ingredients-button]',
}

const classes = {
  show: 'show',
}

const elements = {
  block: null,
  button: null,
}

const cIngredients = () => {
  elements.block = document.querySelector(selectors.block)
  elements.button = elements.block?.querySelector(selectors.button)
  
  if (!elements.block && !elements.button) return null
  
  elements.button.addEventListener('click', onClick)
}

const onClick = (e) => {
  e.preventDefault()
  elements.block.classList.add(classes.show)
}

export default cIngredients
